<template>
    <li class="books-list-item">
        <div class="list-detail">
            <div class="title">{{ item.title }}</div>
            <p class="container">{{ item.desc }}</p>
            <div class="count">
                <span class="book-count">{{ item.bookCount }}本 · </span>
                <span class="collector-count">{{ getCollectorCount(item.collectorCount) }} · </span>
                <span class="read-count">{{ getReadCount(item.readCount) }}</span>
            </div>
        </div>
        <img :src="getImgCover(item.cover)" alt="" v-lazy="getImgCover(item.cover)" data-loading="../assets/imgloading.gif" data-error="../assets/wrong.png"/>
    </li>
</template>

<script>
export default {
    props: ["item"],
    methods: {
        getCollectorCount(num) {
            if (num > 10000) {
                let n = num / 10000;
                return n.toFixed(1) + "万收藏";
            } else {
                return num + "收藏";
            }
        },
        getReadCount(num) {
            if (num > 10000) {
                let n = num / 10000;
                return n.toFixed(1) + "万阅读";
            } else {
                return num + "阅读";
            }
        },
        getImgCover(url) {
            return "https://statics.zhuishushenqi.com" + url;
        }
    }
};
</script>

<style lang="less">
li.books-list-item {
    &:last-child{
        margin-bottom: 50px;
    }
    position: relative;
    padding: 15px;
    margin: 15px 0;
    display: flex;
    border-bottom: 1px solid rgb(241, 241, 241);

    .list-detail {
        flex: 1;
        .title {
            font-weight: 600;
        }
        p.container {
            color: #666;
            font-size: 14px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
        }
        .count {
            font-size: 12px;
            color: #999;
            span {
                margin: 0 3px;
            }
        }
    }
    img {
        width: 70px;
        height: 100px;
        margin-left: 15px;
        border-radius: 2px;
        box-shadow: 0 2px 1px 2px rgba(0, 0, 0, 0.15);
    }
}
</style>
